export enum PreventivniExaminationType {
    PREDHODNI = 'PREDHODNI',
    KONTROLNI = 'KONTROLNI',
    OBDOBNI = 'OBDOBNI',
}
